import { create } from 'zustand';

interface BonusStore {
  bonus: boolean;
  setBonus: (bonus: boolean) => void;
  bonusAmount: number;
  setBonusAmount: (bonusAmount: number) => void;
}

const useBonusStore = create<BonusStore>((set) => ({
  bonus: false,
  setBonus: (bonus: boolean) => set({ bonus }),
  bonusAmount: 0,
  setBonusAmount: (bonusAmount: number) => set({ bonusAmount }),
}));

export default useBonusStore;
